import { useFormContext } from "react-hook-form";
import { RadioFieldProps } from "./Radio.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import RadioCards from "@shadcn/components/ui/radio-group-cards";
import { Label } from "@shadcn/components/ui/label";

// Based this input on https://www.shadcnui-blocks.com/components/radio-group

export const Radio = ({ config, required, validation, label, name, disabled }: RadioFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
      }}
      defaultValue={config.options?.find((option) => option.isDefault)?.value}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <RadioCards
              options={config.options}
              defaultValue={config.options?.find((option) => option.isDefault)?.value}
              value={field.value}
              disabled={disabled}
              onValueChange={field.onChange}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};

